import { push } from 'react-router-redux';
import storage from '../utils/storage';
import { AUTH_LOGIN_SUCCESS, AUTH_LOGOUT, setToken } from '../reducers/auth';
import { CONTROL_GET_ROOT_ERROR } from '../reducers/controls';
import auth0 from 'auth0-js';
import { doLogin } from '../reducers/auth';
import { toastr } from 'react-redux-toastr';
import { Auth0Config } from './Auth0Config';

const defaultTokenExpiresIn = 7200;

export const createSession = (accessToken, idToken, expiresIn) => {
  let expiresAt = JSON.stringify(
    storage.get('expiresIn')
      ? storage.get('expiresIn') * 1000 + new Date().getTime()
      : expiresIn * 1000 + new Date().getTime()
  );
  storage.set('accessToken', accessToken);
  storage.set('id_token', idToken);
  storage.set('expiresIn', defaultTokenExpiresIn);
  storage.set('expires_at', expiresAt);
};

const clearSession = () => {
  storage.remove('accessToken');
  storage.remove('id_token');
  storage.remove('expiresIn');
  storage.remove('expires_at');
};

const auth0Config = Auth0Config();
let auth = new auth0.WebAuth({
  domain: auth0Config.domain,
  clientID: auth0Config.client,
  redirectUri: window.location.origin + '/login',
  audience: 'https://employer.bcidaho.com',
  responseType: 'token id_token',
  scope: 'openid',
  realm: 'B2B'
});

const handleAuthentication = store => {
  auth.parseHash((err, authResult) => {
    if (authResult && authResult.accessToken && authResult.idToken) {
      createSession(authResult, authResult.idToken, defaultTokenExpiresIn);
      store.dispatch(doLogin(authResult.accessToken, authResult.idToken));
    } else if (!isAuthenticated()) {
      clearSession();
      auth.authorize();
    }
  });
};

export const login = employerId => {
  const config = {
    domain: auth0Config.domain,
    clientID: auth0Config.client,
    redirectUri: window.location.origin + '/switch',
    audience: 'https://employer.bcidaho.com',
    responseType: 'token id_token',
    scope: 'openid',
    prompt: 'none',
    realm: 'B2B'
  };
  if (employerId) {
    config.scope = `openid employerId:${employerId}`;
  }
  auth = new auth0.WebAuth(config);
  auth.authorize(config);
};

export const changePassword = email => {
  let params = Object.assign({
    domain: auth0Config.domain,
    clientID: auth0Config.client,
    redirectUri: window.location.origin,
    responseType: 'token id_token'
  });

  let webAuth = new auth0.WebAuth(params);

  return webAuth.changePassword(
    {
      connection: 'B2B',
      email: email
    },
    function (err, resp) {
      if (err) {
        toastr.error(
          'Password Reset',
          'A problem occurred while attempting to send a password reset email to: ' + email
        );
      } else {
        toastr.success('Password Reset', 'A password reset email has been sent to: ' + email);
      }
    }
  );
};

const isAuthenticated = () => {
  let expiresAt = JSON.parse(sessionStorage.getItem('expires_at'));
  return new Date().getTime() < expiresAt;
};

const AuthenticationMiddleware = store => next => action => {
  //const { getQueryParams } = this.props;
  let result = next(action);
  let invitationTimeout =
    typeof action.payload !== 'undefined' &&
    action.payload.pathname === '/' &&
    window.location.search.indexOf('message=Access%20expired.&success=false') !== -1;
  if (!isAuthenticated() && window.location.pathname !== '/error' && !invitationTimeout) {
    handleAuthentication(store);
  }
  if (action && action.type) {
    switch (action.type) {
      case '@@router/LOCATION_CHANGE':
        const accessToken = storage.get('accessToken');
        const idToken = storage.get('idToken');

        /* if (action.payload.pathname.includes('/account-setup')) {
                    let subStr = action.payload.search.substring(action.payload.search.lastIndexOf('email='), action.payload.search.lastIndexOf('&message'));
                    let email = subStr.split('=');
                    return store.dispatch(push(action.payload.pathname + '&email=' + email[1]));
                } else  */

        if (action.payload.pathname === '/login' && accessToken) {
          return store.dispatch(push('/'));
        } else if (action.payload.pathname === '/error' && !accessToken && !isAuthenticated()) {
          return result;
        } else if (!isAuthenticated() && !accessToken && invitationTimeout) {
          return store.dispatch(
            push('/error?error_description=Access%20expired.&lang=en-US%2Cen%3Bq%3D0.9#&context=onboarding')
          );
        } else if (action.payload.pathname !== '/login' && !accessToken && !isAuthenticated()) {
          return store.dispatch(push('/login'));
        } else if (accessToken && isAuthenticated()) {
          createSession(accessToken, idToken, defaultTokenExpiresIn);
          let inLogin = setToken(storage.get('accessToken'), storage.get('id_token'));
          return store.dispatch(inLogin);
        } else {
          return result;
        }

      case AUTH_LOGIN_SUCCESS:
        createSession(action.accessToken, action.idToken, action.expiresIn);
        setToken(action.accessToken, action.idToken);
        window.location.href = '/';
        break;

      case AUTH_LOGOUT:
        clearSession();
        const { logoutUrl } = auth0Config;
        window.location.replace(logoutUrl);
        break;

      case CONTROL_GET_ROOT_ERROR:
        clearSession();
        break;

      default:
        return result;
    }
  }

  return result;
};

export default AuthenticationMiddleware;
